import React from 'react';
import HomeBanner from './HomeBanner';
import './index.scss';
import { useTranslation } from 'react-i18next';
import CategoriesCoursesSection from './CategoryCoursesSection/CategoriesCoursesSection';
import PlanSection from './PlanSection/PlanSection';
import TeacherSection from './TeacherSection/TeacherSection';
import JoinCommunitySection from './JoinCommunitySection/JoinCommunitySection';
import FeaturedCoursesSection from './FeaturedCoursesSection/FeaturedCoursesSection';
import RegisterBanner from './RegisterBanner/RegisterBanner';
import CategoriesSection from './CategoriesSection/CategoriesSection';
import PopularCoursesSection from './PopularCoursesSection/PopularCoursesSection';
import { AuthConsumer } from 'shared/contexts/AuthContext';
import AboutSection from './AboutSection/AboutSection';
import ReviewSection from './ReviewSection/ReviewSection';
import NewsEventSection from './NewsEventSection';
import LoginPage from 'views/login/Login';

interface Props {
    location: any;
}

export default function HomePage(props: Props) {
    const { t } = useTranslation();

     return (
        <AuthConsumer>
            {({ isAuth }) =>
                isAuth ? (
                    <div className={'home-wrapper'}>
                        <HomeBanner/>
                        <CategoriesSection/>
                        {/* <AboutSection/> */}
                        <CategoriesCoursesSection/>
                        {/* <FeaturedCoursesSection/> */}
                        <PopularCoursesSection/>
                        {/* <ReviewSection/> */}
                        {/* <NewsEventSection/> */}

                        {/* <TeacherSection/> */}
                        {/* <JoinCommunitySection/> */}
                        {/* <AuthConsumer>
                            {({ isAuth,updateCartTime }) =>
                                isAuth ? (
                                    <> <PlanSection updateCartTime={updateCartTime}/></>
                                ) : <RegisterBanner/>

                            }
                        </AuthConsumer> */}
                    </div>
                ) : (
                    // clear all subscription or stuff that cause memory leak when user gets redirected to login page

                    <LoginPage location={props.location}/>
                    // <Redirect to="/login" />
                )
            }
        </AuthConsumer>
    );
}
